/**
 * WinGrow EC Site - Shopify Theme JavaScript
 * wg- プレフィックスで Shopify 既存 JS と競合を回避
 */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================
  // Navigation Link Fix (キャッシュ対策)
  // Shopifyセクションキャッシュが旧URLを返す場合の即時修正
  // ============================================
  (function() {
    var fixes = {
      '/search?q=かに&type=product': '/collections/kani',
      '/search?q=魚介類&type=product': '/collections/gyokairui',
      '/search?q=海鮮加工品&type=product': '/collections/kaisen-kakouhin',
      '/#shopify-section-wg-product-ranking': '/collections/ranking',
      '/#shopify-section-wg-sale-products': '/collections/sale',
      '/#shopify-section-wg-featured': '/products/striped-atka-mackerel'
    };
    document.querySelectorAll('.wg-header__nav a, .wg-menu-drawer__nav a, .wg-menu-drawer__dropdown-menu a').forEach(function(link) {
      var href = link.getAttribute('href');
      if (href && fixes[href]) link.setAttribute('href', fixes[href]);
    });
    // お買い得品リンク削除（settings_data.jsonから除外済みだがキャッシュ残存の場合）
    document.querySelectorAll('.wg-header__nav a, .wg-menu-drawer__nav a').forEach(function(link) {
      if (link.getAttribute('href') === '/#shopify-section-wg-sale-products' || link.getAttribute('href') === '/collections/sale') {
        // お買い得品はメニューから除外予定なら: link.closest('li').style.display='none';
      }
    });
  })();

  // ============================================
  // Hero Slider (3-column peek style, infinite loop)
  // 実装方針: 最初のスライドを末尾に、最後のスライドを先頭にクローン配置。
  // 端に到達したら transitionend で瞬時スナップし、シームレスに継続。
  // ============================================
  const heroTrack = document.getElementById('wgHeroTrack');
  const realSlides = Array.from(document.querySelectorAll('.wg-hero__slide'));
  const dots = document.querySelectorAll('.wg-hero__dot');
  const N = realSlides.length;

  if (heroTrack && N > 0) {
    // 先頭/末尾にクローンを配置
    const lastClone = realSlides[N - 1].cloneNode(true);
    const firstClone = realSlides[0].cloneNode(true);
    lastClone.classList.add('wg-hero__slide--clone');
    firstClone.classList.add('wg-hero__slide--clone');
    lastClone.classList.remove('active');
    firstClone.classList.remove('active');
    heroTrack.insertBefore(lastClone, realSlides[0]);
    heroTrack.appendChild(firstClone);

    const allSlides = Array.from(heroTrack.querySelectorAll('.wg-hero__slide'));
    const M = allSlides.length; // N + 2
    let virtualIndex = 1; // 最初の実スライド位置
    let sliderInterval;
    let isSnapping = false;

    // デスクトップ: 3カラムpeek（65%） / モバイル: 全幅1スライド（100%）
    function getSlideGeom() {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const w = isMobile ? 100 : 65;
      return { SLIDE_W: w, PEEK: (100 - w) / 2 };
    }
    const TRANSITION = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

    function applyTransform(animated) {
      heroTrack.style.transition = animated ? TRANSITION : 'none';
      const { SLIDE_W, PEEK } = getSlideGeom();
      const offset = virtualIndex * SLIDE_W - PEEK;
      heroTrack.style.transform = `translateX(-${offset}%)`;
    }

    // ブレイクポイントを跨いだリサイズで位置ズレを修正
    window.addEventListener('resize', function () {
      applyTransform(false);
    });

    function setActive() {
      allSlides.forEach(s => s.classList.remove('active'));
      if (allSlides[virtualIndex]) allSlides[virtualIndex].classList.add('active');
      dots.forEach(d => d.classList.remove('active'));
      // dots は実スライド(N個)に対応。virtualIndex 1..N が実、0/M-1 はクローン
      const realIdx = ((virtualIndex - 1) % N + N) % N;
      if (dots[realIdx]) dots[realIdx].classList.add('active');
    }

    function nextSlide() {
      if (isSnapping) return;
      virtualIndex++;
      applyTransform(true);
      setActive();
    }

    function goTo(realIdx) {
      if (isSnapping) return;
      virtualIndex = realIdx + 1; // 先頭クローン分をスキップ
      applyTransform(true);
      setActive();
    }

    // クローン到達時、瞬時に対応する実スライドへスナップ
    heroTrack.addEventListener('transitionend', function (e) {
      if (e.target !== heroTrack || e.propertyName !== 'transform') return;
      if (virtualIndex === M - 1) {
        // firstClone 到達 → 実の最初(1)へスナップ
        isSnapping = true;
        virtualIndex = 1;
        applyTransform(false);
        setActive();
        // 強制リフロー後、スナップ状態を解除
        void heroTrack.offsetHeight;
        setTimeout(function () { isSnapping = false; }, 30);
      } else if (virtualIndex === 0) {
        // lastClone 到達 → 実の最後(N)へスナップ
        isSnapping = true;
        virtualIndex = N;
        applyTransform(false);
        setActive();
        void heroTrack.offsetHeight;
        setTimeout(function () { isSnapping = false; }, 30);
      }
    });

    function startSlider() {
      sliderInterval = setInterval(nextSlide, 4500);
    }
    function stopSlider() { clearInterval(sliderInterval); }

    // 初期描画
    applyTransform(false);
    setActive();

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopSlider();
        goTo(i);
        startSlider();
      });
    });

    allSlides.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (i !== virtualIndex && !isSnapping) {
          stopSlider();
          virtualIndex = i;
          applyTransform(true);
          setActive();
          startSlider();
        }
      });
    });

    startSlider();

    // bfcache / 履歴戻り対応: ページ復元時にスライダー状態をリセット
    window.addEventListener('pageshow', function (event) {
      if (event.persisted && heroTrack) {
        try {
          clearInterval(sliderInterval);
          virtualIndex = 1;
          isSnapping = false;
          applyTransform(false);
          setActive();
          sliderInterval = setInterval(nextSlide, 4500);
        } catch (_) {}
      }
    });

    // タブ非アクティブ時の対策:
    // setInterval は throttle されつつ動き続けるが、ブラウザは hidden 中に
    // CSS transition を確実には進めないため transitionend が発火せず、
    // virtualIndex がオーバーフローして復帰時に空白が表示される。
    // → hidden で一時停止し、visible 復帰時に状態をリセットして再開する。
    document.addEventListener('visibilitychange', function () {
      if (!heroTrack) return;
      if (document.hidden) {
        clearInterval(sliderInterval);
        sliderInterval = null;
      } else {
        try {
          if (sliderInterval) clearInterval(sliderInterval);
          virtualIndex = 1;
          isSnapping = false;
          applyTransform(false);
          setActive();
          sliderInterval = setInterval(nextSlide, 4500);
        } catch (_) {}
      }
    });
  }

  // ============================================
  // Sticky Header Shadow
  // ============================================
  const header = document.querySelector('.wg-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
      } else {
        header.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      }
    });
  }

  // ============================================
  // Cart Badge Counter (Shopify Ajax Cart API 対応)
  // ============================================
  const cartBadge = document.querySelector('.wg-cart-badge');

  // Shopify カート更新イベントを購読
  document.addEventListener('cart:change', function (event) {
    if (cartBadge && event.detail && event.detail.cart) {
      const count = event.detail.cart.item_count;
      cartBadge.textContent = count;
    }
  });

  // カートボタンのクリック処理（Ajax でカートに追加）
  const cartBtns = document.querySelectorAll('.wg-btn-cart');
  cartBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;

      if (!variantId) return;

      const originalHTML = this.innerHTML;
      this.disabled = true;

      // Shopify Ajax Cart API でカートに追加
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(() => {
          // カートの件数を更新
          return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
          if (cartBadge) {
            cartBadge.textContent = cart.item_count;
          }

          // 完了アニメーション
          this.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            カートに追加しました
          `;
          this.style.background = '#2ecc71';
          setTimeout(() => {
            this.innerHTML = originalHTML;
            this.style.background = '';
            this.disabled = false;
          }, 1500);
        })
        .catch(() => {
          this.disabled = false;
        });
    });
  });

  // ============================================
  // Intersection Observer for Fade-in Animation
  // ============================================
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('wg-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.wg-product-card, .wg-category-card, .wg-purpose__image-card').forEach(el => {
    el.classList.add('wg-fade-in');
    observer.observe(el);
  });

  // ============================================
  // 数量ボタン（商品ページ）
  // ============================================
  document.querySelectorAll('.wg-product-detail__quantity-wrap').forEach(function(wrap) {
    var input = wrap.querySelector('.wg-product-detail__quantity-input');
    var minus = wrap.querySelector('.wg-quantity-btn--minus');
    var plus = wrap.querySelector('.wg-quantity-btn--plus');
    if (input && minus && plus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
      plus.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  });

  // ============================================
  // 数量ボタン（カートページ）+ 数量変更の送信
  // ============================================
  document.querySelectorAll('.wg-cart-item__quantity').forEach(function(wrap) {
    var input = wrap.querySelector('.wg-cart-item__quantity-input');
    var minus = wrap.querySelector('.wg-quantity-btn--minus');
    var plus = wrap.querySelector('.wg-quantity-btn--plus');
    if (!input) return;
    var line = input.dataset.line;

    function updateCart(newQty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: newQty })
      }).then(function() { window.location.reload(); });
    }

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        updateCart(Math.max(0, val - 1));
      });
    }
    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        updateCart(val + 1);
      });
    }
    input.addEventListener('change', function() {
      updateCart(parseInt(input.value, 10) || 0);
    });
  });

  // ============================================
  // バリアント選択 → hidden input + 画像 + 価格更新
  // ============================================
  (function() {
    var variantIdInput = document.getElementById('ProductVariantId');
    var selects = document.querySelectorAll('.wg-product-detail__option-select');
    if (!variantIdInput || selects.length === 0) return;

    // Shopifyが出力するバリアントJSONを取得
    var productJson = null;
    try {
      var metaTag = document.querySelector('[data-product-json]');
      if (metaTag) productJson = JSON.parse(metaTag.textContent);
    } catch(e) {}

    // meta.product.variantsからも試行
    if (!productJson) {
      try {
        var scripts = document.querySelectorAll('script');
        scripts.forEach(function(s) {
          var text = s.textContent;
          if (text.indexOf('"product"') > -1 && text.indexOf('"variants"') > -1) {
            var match = text.match(/var\s+meta\s*=\s*(\{[^;]+\})/);
            if (match) {
              var m = JSON.parse(match[1]);
              if (m.product && m.product.variants) {
                productJson = m.product;
              }
            }
          }
        });
      } catch(e) {}
    }

    selects.forEach(function(select) {
      select.addEventListener('change', function() {
        // 選択中の全オプション値を取得
        var selectedOptions = [];
        selects.forEach(function(s) { selectedOptions.push(s.value); });

        // URLパラメータを更新（Mikawayaウィジェット連携用）
        var url = new URL(window.location);
        // バリアントマッチング（productJsonがある場合）
        if (productJson && productJson.variants) {
          var matched = productJson.variants.find(function(v) {
            var opts = [v.option1, v.option2, v.option3].filter(Boolean);
            return selectedOptions.every(function(so, i) { return opts[i] === so; });
          });
          if (matched) {
            variantIdInput.value = matched.id;
            url.searchParams.set('variant', matched.id);
            window.history.replaceState({}, '', url.toString());
          }
        } else {
          // バリアントJSONが取れない場合、URLパラメータ更新のみ（Mikawayaポーリングが拾う）
          url.searchParams.set('option', selectedOptions.join('+'));
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  })();

  // ============================================
  // コレクション並び替え
  // ============================================
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
  }

  // ============================================
  // Product Gallery Thumbnail Switcher
  // ============================================
  const productMainImg = document.getElementById('product-main-img');
  const thumbBtns = document.querySelectorAll('.wg-product-gallery__thumb-btn');

  if (productMainImg && thumbBtns.length > 0) {
    thumbBtns.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const newSrc = this.dataset.src;
        if (!newSrc) return;

        // メイン画像を切り替え
        productMainImg.src = newSrc;

        // アクティブ状態を更新
        thumbBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

});
